import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import axios from 'axios';

import { store, persistor } from './store';
import * as serviceWorker from './serviceWorker';
import route from './routes/routes';

import './assets/css/vendor.css';
import './assets/css/elephant.css';
import './assets/css/application.css';
import 'react-tabs/style/react-tabs.css';
import './assets/css/style-custom.css';
import './assets/css/light-mode.css';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.css';

axios.defaults.headers = {
  'Cache-Control': 'no-cache'
};

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <PersistGate persistor={persistor}>
        <Suspense fallback={<div>Loading...</div>}>        
          <Switch>
          {route.map((e, i) => {
            const index = i + 1;
            return (
              <Route key={`pages-${index}`} exact path={e.url}>
                  {e.page}
                </Route>
            );
          })}
          </Switch>
        </Suspense>
      </PersistGate>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
